export enum ECertificateStatus {
  ACTIVE = "Active",
  EXPIRED = "Expired",
  REVOKED = "Revoked",
}
